/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationSubFieldModel } from '../../models/education-sub-field-model';

export interface EducationSubFieldIdGet$Params {
  id: string;
}

export function educationSubFieldIdGet(http: HttpClient, rootUrl: string, params: EducationSubFieldIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<EducationSubFieldModel>> {
  const rb = new RequestBuilder(rootUrl, educationSubFieldIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<EducationSubFieldModel>;
    })
  );
}

educationSubFieldIdGet.PATH = '/EducationSubField/{id}';
